<template>
  <div class="add-product-holder">
    <b-card no-body>
      <b-tabs pills card>
        <b-tab title="Fields">
          <b-card-text>
            <div class="basic-product">
              <CRow>
                <CCol class="col-12 mb-3">
                  <label class="required">Category</label>
                  <div class="dropdown_wrapper">
                    <v-select multiple id="product_category" v-model="form.category_ids" :options="formattedCategories"
                      name="product_category" placeholder="Select category" />
                  </div>
                </CCol>
              </CRow>
              <CRow>
                <CCol>
                  <template v-if="product_styles.length > 0">
                    <b-tabs pills card class="fixed-logo-tabs mt-5 mb-5" v-model="active_style_index">

                      <b-tab v-for="(style, style_idx) in product_styles" :key="'style-' + style_idx"
                        :title="style.tab_title">

                        <b-card-text>
                          <CRow class="my-2">
                            <CCol class="col-6">
                              <div class="d-flex align-items-center gap-3">
                                <div>
                                  <label class="custom-radio cursor-pointer align-items-start">
                                    <span class="mt-1">
                                      <input type="radio" :name="`prices_selection_${style_idx}`" :value="true"
                                        v-model="style.is_fixed_logos_all" />
                                      <span class="radio_icon"></span>
                                    </span>
                                    <span class="fs-3" @change="() => getStyleAllLogoState(style)">All</span>
                                  </label>
                                </div>
                                <div>
                                  <label class="custom-radio cursor-pointer align-items-start">
                                    <span class="mt-1">
                                      <input type="radio" :name="`prices_selection_${style_idx}`" :value="false"
                                        v-model="style.is_fixed_logos_all" />
                                      <span class="radio_icon"></span>
                                    </span>
                                    <span class="fs-3" @change="() => getStyleAllLogoState(style)">Either</span>
                                  </label>
                                </div>
                              </div>
                            </CCol>

                            <CCol class="col col-6 d-flex justify-content-end">
                              <b-button variant="primary" class="mr-2" v-if="!style.is_fixed_logos_all"
                                @click.prevent="showCreateGroupModal()">Create Group</b-button>
                              <b-button variant="primary" @click.prevent="replicateToAllStyles(style_idx)">Replicate
                                from {{ style.tab_title }} to All Styles</b-button>
                            </CCol>
                          </CRow>

                          <!-- All section starts-->
                          <template v-if="style.is_fixed_logos_all">
                            <!-- All section Header starts -->
                            <CRow>
                              <CCol class="col-12 border-top pt-3 mt-3">
                                <CRow>
                                  <div class="col-12 d-flex">
                                    <CCol class="col-1">
                                      <div class="image-holder flex-shrink-0"
                                        style="max-width:fit-content;width: 170px;">
                                        <h5>Logo</h5>
                                      </div>
                                    </CCol>
                                    <CCol class="col-4">
                                      <div class="align-fields d-flex">
                                        <h5 class="mr-2" style="width:50%">Placement Title</h5>
                                        <h5 class="mr-2" style="width:50%">X Axis</h5>
                                        <h5 class="ml-2" style="width:50%">Y Axis</h5>
                                      </div>
                                    </CCol>
                                    <CCol class="col-4">
                                      <div class="customize-setting-holder d-flex justify-content-between">
                                        <div class="rotate-logo-area" style="width:25%;">
                                          <h5 class="mr-2">Rotation</h5>
                                        </div>
                                        <h5 class="mx-2" style="width:15%;">Height</h5>
                                        <div class="shirt-side-area mx-2" style="width:49% ">
                                          <h5 class="mx-2">Placement Position</h5>
                                        </div>
                                      </div>
                                    </CCol>
                                    <CCol class="col-1 d-flex justify-content-center">
                                      <div class="align-fields d-flex" style="min-width: 0">
                                        <h5 class="mx-2 text-center" style="overflow-wrap: anywhere; min-width: 0">Customizable</h5>
                                      </div>
                                    </CCol>
                                    <CCol class="col-1 d-flex justify-content-center">
                                      <div class="align-fields d-flex" style="min-width: 0">
                                        <h5 class="mx-2 text-center" style="overflow-wrap: anywhere; min-width: 0" title="Locked: the customer cannot move, resize or rotate the logo">Locked</h5>
                                      </div>
                                    </CCol>
                                    <CCol class="col-1 d-flex justify-content-center" v-if="!style.is_fixed_logos_all">
                                      <div class="align-fields d-flex">
                                        <h5 class="mx-2">Default</h5>
                                      </div>
                                    </CCol>
                                  </div>
                                </CRow>
                              </CCol>
                            </CRow>
                            <!-- All section Header ends -->
                            <CRow class="my-1" v-if="style.fixed_logos.length > 0">
                              <CCol class="col-12">
                                <CRow v-for="(item, logoindex) in style.fixed_logos" :key="'logo-' + logoindex"
                                  class="my-3">
                                  <div class="col-12 d-flex align-items-center rounded-lg py-3 border border-light-gray"
                                    :class="{ 'bg-light-gray': logoindex % 2 !== 0 }">
                                    <span class="remove-icon" v-if="logoindex != 0"
                                      @click="removeLogoPlacement(style_idx, logoindex)">
                                      <BIconX />
                                    </span>
                                    <template>
                                      <ValidationObserver :ref="`observer-style-${style_idx}-${logoindex}`"
                                        class="d-flex align-items-center">
                                        <CCol class="col-1">
                                          <validation-provider rules="" v-slot="{ errors }" name="Logo Image">
                                            <div class="image-holder flex-shrink-0"
                                              style="max-width:fit-content;width: 170px;"
                                              :class="errors && errors[0] ? 'v-image' : ''">
                                              <img v-if="item.logo_url == ''"
                                                class="default-logo border border-secondary rounded-sm cursor-pointer w-100"
                                                @click="setStyleFixedLogo(style_idx, logoindex)"
                                                src="../../assets/images/dummy-t.png" />
                                              <img v-else
                                                class="selected_logo border border-secondary p-2 rounded-sm cursor-pointer w-100"
                                                @click="setStyleFixedLogo(style_idx, logoindex)"
                                                :src="base_url + '/' + item.logo_url" style="width:100%;height:100%" />
                                              <CInput addLabelClasses="required" placeholder="Logo Image" type="hidden"
                                                v-model="item.logo_url"
                                                :name="`fixed_logo_image_${style_idx}_${logoindex}`"
                                                :id="`fixed_logo_image_${style_idx}_${logoindex}`">
                                              </CInput>
                                              <span class="error mt-1 d-block">{{ errors[0] }}</span>
                                            </div>
                                          </validation-provider>
                                        </CCol>
                                        <CCol class="col-4">
                                          <div class="align-fields d-flex">
                                            <validation-provider :rules="item.logo_url ? 'required' : ''" v-slot="{ errors }" name="Title">
                                              <CInput addLabelClasses="required" class="mr-2" placeholder="Title"
                                                type="text" v-model="item.placement_title"
                                                :name="`placement_title_${style_idx}_${logoindex}`"
                                                :id="`placement_title_${style_idx}_${logoindex}`"
                                                :class="errors && errors[0] ? 'v-error' : ''">
                                              </CInput>
                                              <span class="error mt-1 mr-2 d-block">{{ errors[0] }}</span>
                                            </validation-provider>
                                            <validation-provider :rules="item.logo_url ? 'required|decimal:5' : ''" v-slot="{ errors }"
                                              name="X">
                                              <CInput addLabelClasses="required" class="mr-2" placeholder="X"
                                                type="text" v-model="item.x_axis"
                                                :name="`logo_position_x_${style_idx}_${logoindex}`"
                                                :id="`logo_position_x_${style_idx}_${logoindex}`"
                                                :class="errors && errors[0] ? 'v-error' : ''">
                                              </CInput>
                                              <span class="error mt-1 mr-2 d-block">{{ errors[0] }}</span>
                                            </validation-provider>
                                            <validation-provider :rules="item.logo_url ? 'required|decimal:5' : ''" v-slot="{ errors }"
                                              name="Y">
                                              <CInput addLabelClasses="required" class="ml-2" placeholder="Y"
                                                type="text" v-model="item.y_axis"
                                                :name="`logo_position_y_${style_idx}_${logoindex}`"
                                                :class="errors && errors[0] ? 'v-error' : ''"
                                                :id="`logo_position_y_${logoindex}`">
                                              </CInput>
                                              <span class="error mt-1 ml-2 d-block">{{ errors[0] }}</span>
                                            </validation-provider>
                                          </div>
                                        </CCol>
                                        <CCol class="col-4">
                                          <div class="customize-setting-holder d-flex justify-content-between">
                                            <div class="rotate-logo-area">
                                              <validation-provider :rules="item.logo_url ? 'required|decimal:5' : ''" v-slot="{ errors }"
                                                name="Rotation">
                                                <CInput addLabelClasses="required" class="mr-2" placeholder="rot°"
                                                  type="text" v-model="item.rotation"
                                                  :name="`logo_rotate_${style_idx}_${logoindex}`"
                                                  :class="errors && errors[0] ? 'v-error' : ''"
                                                  :id="`logo_rotate_${style_idx}_${logoindex}`">
                                                </CInput>
                                                <span class="error mt-1 mr-2 d-block">{{ errors[0] }}</span>
                                              </validation-provider>
                                            </div>
                                            <validation-provider :rules="item.logo_url ? 'required|decimal:5' : ''" v-slot="{ errors }"
                                              name="Height">
                                              <CInput addLabelClasses="required" class="mx-2" placeholder="height"
                                                type="text" v-model="item.height"
                                                :name="`logo_height_${style_idx}_${logoindex}`"
                                                :class="errors && errors[0] ? 'v-error' : ''"
                                                :id="`logo_height_${style_idx}_${logoindex}`">
                                              </CInput>
                                              <span class="error mt-1 mx-2 d-block">{{ errors[0] }}</span>
                                            </validation-provider>
                                            <div class="shirt-side-area mx-2" style="width:100% ">
                                              <div class="dropdown_wrapper">
                                                <validation-provider :rules="item.logo_url ? 'required' : ''" v-slot="{ errors }" name="Side">
                                                  <v-select :name="`logo_side_${style_idx}_${logoindex}`"
                                                    v-model="item.side" :options="sideOptions" placeholder="Front"
                                                    :class="errors && errors[0] ? 'v-error' : ''"
                                                    :id="`logo_side_${style_idx}_${logoindex}`"></v-select>
                                                  <span class="error mt-1 d-block">{{ errors[0] }}</span>
                                                </validation-provider>
                                              </div>
                                            </div>
                                          </div>
                                        </CCol>
                                        <CCol class="col-1">
                                          <div class="align-fields gap-1 d-flex justify-content-center">
                                            <label class="custom-radio align-items-start">
                                              <span class="mt-3">
                                                <input type="checkbox" :id="`fixed_logo_customizable_${logoindex}`"
                                                  :name="`logo_is_customizable_${style_idx}`"
                                                  v-model="item.is_customizable" />
                                                <span class="radio_icon"></span>
                                              </span>
                                            </label>
                                          </div>
                                        </CCol>
                                        <CCol class="col-1">
                                          <div class="align-fields gap-1 d-flex justify-content-center">
                                            <!-- AB#22275: unticked = the customer may move, resize and rotate this logo (recolouring is the Customizable box) -->
                                            <label class="custom-radio align-items-start"
                                              title="Locked: the customer cannot move, resize or rotate this logo. Untick to let them.">
                                              <span class="mt-3">
                                                <input type="checkbox" :id="`fixed_logo_locked_${style_idx}_${logoindex}`" :name="`logo_is_locked_${style_idx}`"
                                                  v-model="item.is_locked" />
                                                <span class="radio_icon"></span>
                                              </span>
                                            </label>
                                          </div>
                                        </CCol>
                                        <CCol class="col-1 d-flex justify-content-center">
                                          <div class="align-fields gap-1 d-flex">
                                            <label class="custom-radio align-items-start"
                                              v-if="!style.is_fixed_logos_all">
                                              <span class="mt-3">
                                                <input type="radio" :id="`fixed_logo_default_${logoindex}`"
                                                  :name="`logo_is_default_${style_idx}`" :value="true"
                                                  v-model="item.is_default"
                                                  @change="handleDefault($event, style_idx, logoindex)" />
                                                <span class="radio_icon"></span>
                                              </span>
                                            </label>
                                            <b-button variant="primary" size="sm"
                                              v-if="logoindex === 0 && style.fixed_logos.length <= 1"
                                              @click.prevent="clearLogoPlacement(style_idx, logoindex)"
                                              class="ml-2 align-self-center">Clear</b-button>
                                          </div>
                                        </CCol>
                                      </ValidationObserver>
                                    </template>
                                  </div>

                                </CRow>
                                <div class="d-flex justify-content-end">
                                  <b-button @click="AddLogoPlacement(style_idx)" class="btn-add-fields mt-3">
                                    <BIconPlus />
                                  </b-button>
                                </div>
                              </CCol>
                            </CRow>
                          </template>

                          <!-- All section ends-->

                          <!-- Either Section starts -->
                          <template v-if="!style.is_fixed_logos_all">
                            <!-- Grouped Logos starts -->
                            <div v-for="(group, groupName) in style.grouped_logos_info.grouped_logos"
                              :key="'group-' + groupName" class="mt-4">
                              <CRow>
                                <CCol>
                                  <div class="group-border position-relative"
                                    style="border: 1px solid #ccc; padding: 15px; border-radius: 8px;">
                                    <span class="remove-icon" @click="confirmGroupDeletion( groupName)">
                                      <BIconX />
                                    </span>

                                    <!-- Group Title -->
                                    <CRow>
                                      <CCol class="col-12 d-flex justify-content-between align-items-center">
                                        <div class="d-flex justify-content-between align-items-center">
                                          <h5 class="mb-2 rounded  text-capitalize group-name-heading">{{ group.title }}
                                          </h5>
                                          <button class="mb-2 rounded btn button" @click="editGroupNew(groupName)">
                                            <b-icon icon="pencil-square" aria-hidden="true"></b-icon>
                                          </button>
                                        </div>
                                        <div class="d-flex align-items-center">
                                          <label class="mr-2">Default</label>
                                          <label class="custom-radio align-items-center">
                                            <span>
                                              <input type="radio" :id="`group_logo_default_${groupName}`"
                                                :name="`logo_is_default_${style_idx}_${groupName}`" 
                                                :value="true"
                                                v-model="group.is_default"
                                                @change="handleDefault($event, style_idx, null, groupName)" />
                                              <span class="radio_icon"></span>
                                            </span>
                                          </label>
                                        </div>
                                      </CCol>
                                    </CRow>

                                    <!-- Column Headers -->
                                    <CRow class="mt-3">
                                      <CCol class="col-1">
                                        <div class="image-holder flex-shrink-0"
                                          style="max-width: fit-content; width: 170px;">
                                          <h5>Logo</h5>
                                        </div>
                                      </CCol>
                                      <CCol class="col-4">
                                        <div class="align-fields d-flex">
                                          <h5 style="width: 50%;">Placement Title</h5>
                                          <h5 style="width: 25%;">X Axis</h5>
                                          <h5 style="width: 25%;">Y Axis</h5>
                                        </div>
                                      </CCol>
                                      <CCol class="col-5">
                                        <div class="customize-setting-holder d-flex justify-content-between">
                                          <h5 style="width: 25%;">Rotation</h5>
                                          <h5 style="width: 15%;">Height</h5>
                                          <h5 style="width: 49%;">Placement Position</h5>
                                        </div>
                                      </CCol>
                                      <CCol class="col-1 text-center">
                                        <h5 style="overflow-wrap: anywhere">Customizable</h5>
                                      </CCol>
                                      <CCol class="col-1 text-center">
                                        <h5 style="overflow-wrap: anywhere" title="Locked: the customer cannot move, resize or rotate the logo">Locked</h5>
                                      </CCol>
                                    </CRow>

                                    <!-- Group Logos -->
                                    <ValidationObserver :ref="`observer-group-${groupName}`"
                                      class="d-flex align-items-center">
                                      <CRow class="my-1">
                                        <CCol class="col-12">
                                          <!-- Loop through group.logos -->
                                          <CRow v-for="(logo, logoIndex) in group.logos"
                                            :key="'group-logo-' + groupName + '-' + logoIndex" class="my-3">
                                            <div
                                              class="col-12 d-flex align-items-center rounded-lg py-3 border border-light-gray"
                                              :class="{ 'bg-light-gray': logoIndex % 2 !== 0 }">
                                              <template>
                                                <!-- <ValidationObserver :ref="`observer-group-${groupName}-${logoIndex}`"
                                                class="d-flex align-items-center"> -->
                                                <CCol class="col-1">
                                                  <validation-provider rules="required" v-slot="{ errors }"
                                                    name="Logo Image">
                                                    <div class="image-holder flex-shrink-0"
                                                      style="max-width:fit-content;width: 170px;"
                                                      :class="errors && errors[0] ? 'v-image' : ''">
                                                      <img v-if="logo.file.file_url === ''"
                                                        class="default-logo border border-secondary rounded-sm cursor-pointer w-100"
                                                        @click="setStyleFixedLogo(style_idx, logoIndex, style.is_fixed_logos_all, groupName)"
                                                        src="../../assets/images/dummy-t.png" />
                                                      <img v-else
                                                        class="selected_logo border border-secondary p-2 rounded-sm cursor-pointer w-100"
                                                        @click="setStyleFixedLogo(style_idx, logoIndex, style.is_fixed_logos_all, groupName)"
                                                        :src="base_url + '/' + logo.file.file_url"
                                                        style="width:100%;height:100%" />
                                                      <CInput addLabelClasses="required" placeholder="Logo Image"
                                                        type="hidden" v-model="logo.file.file_url"
                                                        :name="`group_logo_image_${groupName}_${logoIndex}`"
                                                        :id="`group_logo_image_${groupName}_${logoIndex}`" />
                                                      <span class="error mt-1 d-block">{{ errors[0] }}</span>
                                                    </div>
                                                  </validation-provider>
                                                </CCol>
                                                <CCol class="col-4">
                                                  <div class="align-fields d-flex">
                                                    <validation-provider rules="required" v-slot="{ errors }"
                                                      name="Title">
                                                      <CInput addLabelClasses="required" class="mr-2"
                                                        placeholder="Title" type="text" v-model="logo.placement_title"
                                                        :name="`placement_title_${groupName}_${logoIndex}`"
                                                        :id="`placement_title_${groupName}_${logoIndex}`"
                                                        :class="errors && errors[0] ? 'v-error' : ''" />
                                                      <span class="error mt-1 mr-2 d-block">{{ errors[0] }}</span>
                                                    </validation-provider>
                                                    <validation-provider rules="required|decimal:5" v-slot="{ errors }"
                                                      name="X">
                                                      <CInput addLabelClasses="required" class="mr-2" placeholder="X"
                                                        type="text" v-model="logo.x_axis"
                                                        :name="`logo_position_x_${groupName}_${logoIndex}`"
                                                        :id="`logo_position_x_${groupName}_${logoIndex}`"
                                                        :class="errors && errors[0] ? 'v-error' : ''" />
                                                      <span class="error mt-1 mr-2 d-block">{{ errors[0] }}</span>
                                                    </validation-provider>
                                                    <validation-provider rules="required|decimal:5" v-slot="{ errors }"
                                                      name="Y">
                                                      <CInput addLabelClasses="required" class="ml-2" placeholder="Y"
                                                        type="text" v-model="logo.y_axis"
                                                        :name="`logo_position_y_${groupName}_${logoIndex}`"
                                                        :class="errors && errors[0] ? 'v-error' : ''"
                                                        :id="`logo_position_y_${groupName}_${logoIndex}`" />
                                                      <span class="error mt-1 ml-2 d-block">{{ errors[0] }}</span>
                                                    </validation-provider>
                                                  </div>
                                                </CCol>
                                                <CCol class="col-5">
                                                  <div class="customize-setting-holder d-flex justify-content-between">
                                                    <div class="rotate-logo-area">
                                                      <validation-provider rules="required|decimal:5"
                                                        v-slot="{ errors }" name="Rotation">
                                                        <CInput addLabelClasses="required" class="mr-2"
                                                          placeholder="rot°" type="text" v-model="logo.rotation"
                                                          :name="`logo_rotate_${groupName}_${logoIndex}`"
                                                          :class="errors && errors[0] ? 'v-error' : ''"
                                                          :id="`logo_rotate_${groupName}_${logoIndex}`" />
                                                        <span class="error mt-1 mr-2 d-block">{{ errors[0] }}</span>
                                                      </validation-provider>
                                                    </div>
                                                    <validation-provider rules="required|decimal:5" v-slot="{ errors }"
                                                      name="Height">
                                                      <CInput addLabelClasses="required" class="mx-2"
                                                        placeholder="height" type="text" v-model="logo.height"
                                                        :name="`logo_height_${groupName}_${logoIndex}`"
                                                        :class="errors && errors[0] ? 'v-error' : ''"
                                                        :id="`logo_height_${groupName}_${logoIndex}`" />
                                                      <span class="error mt-1 mx-2 d-block">{{ errors[0] }}</span>
                                                    </validation-provider>
                                                    <div class="shirt-side-area mx-2" style="width:100%">
                                                      <div class="dropdown_wrapper">
                                                        <validation-provider rules="required" v-slot="{ errors }"
                                                          name="Side">
                                                          <v-select :name="`logo_side_${groupName}_${logoIndex}`"
                                                            v-model="logo.side" :options="sideOptions" placeholder="Front"
                                                            :class="errors && errors[0] ? 'v-error' : ''"
                                                            :id="`logo_side_${groupName}_${logoIndex}`" />
                                                          <span class="error mt-1 d-block">{{ errors[0] }}</span>
                                                        </validation-provider>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </CCol>
                                                <CCol class="col-1">
                                                  <div class="align-fields gap-1 d-flex justify-content-center">
                                                    <label class="custom-radio align-items-start">
                                                      <span class="mt-3">
                                                        <input type="checkbox"
                                                          :id="`group_logo_customizable_${logoIndex}`"
                                                          :name="`logo_is_customizable_${groupName}`"
                                                          v-model="logo.is_customizable" />
                                                        <span class="radio_icon"></span>
                                                      </span>
                                                    </label>
                                                  </div>
                                                </CCol>
                                                <CCol class="col-1">
                                                  <div class="align-fields gap-1 d-flex justify-content-center">
                                                    <!-- AB#22275: unticked = the customer may move, resize and rotate this logo (recolouring is the Customizable box) -->
                                                    <label class="custom-radio align-items-start"
                                                      title="Locked: the customer cannot move, resize or rotate this logo. Untick to let them.">
                                                      <span class="mt-3">
                                                        <input type="checkbox" :id="`group_logo_locked_${groupName}_${logoIndex}`" :name="`logo_is_locked_${groupName}`"
                                                          v-model="logo.is_locked" />
                                                        <span class="radio_icon"></span>
                                                      </span>
                                                    </label>
                                                  </div>
                                                </CCol>
                                                <!-- </ValidationObserver> -->
                                              </template>
                                            </div>
                                          </CRow>
                                        </CCol>
                                      </CRow>
                                    </ValidationObserver>
                                  </div>
                                </CCol>
                              </CRow>
                            </div>
                            <!-- Grouped Logos ends -->
                            
                            <!-- Ungrouped logos starts-->
                            <template>
                              <!-- Either ungrouped section Header starts -->
                              <CRow>
                                <CCol class="col-12 border-top pt-3 mt-3">
                                  <CRow>
                                    <div class="col-12 d-flex">
                                      <CCol class="col-1">
                                        <div class="image-holder flex-shrink-0"
                                          style="max-width:fit-content;width: 170px;">
                                          <h5>Logo</h5>
                                        </div>
                                      </CCol>
                                      <CCol class="col-4">
                                        <div class="align-fields d-flex">
                                          <h5 class="mr-2" style="width:50%">Placement Title</h5>
                                          <h5 class="mr-2" style="width:50%">X Axis</h5>
                                          <h5 class="ml-2" style="width:50%">Y Axis</h5>
                                        </div>
                                      </CCol>
                                      <CCol class="col-4">
                                        <div class="customize-setting-holder d-flex justify-content-between">
                                          <div class="rotate-logo-area" style="width:25%;">
                                            <h5 class="mr-2">Rotation</h5>
                                          </div>
                                          <h5 class="mx-2" style="width:15%;">Height</h5>
                                          <div class="shirt-side-area mx-2" style="width:49% ">
                                            <h5 class="mx-2">Placement Position</h5>
                                          </div>
                                        </div>
                                      </CCol>
                                      <CCol class="col-1 d-flex justify-content-center">
                                        <div class="align-fields d-flex" style="min-width: 0">
                                          <h5 class="mx-2 text-center" style="overflow-wrap: anywhere; min-width: 0">Customizable</h5>
                                        </div>
                                      </CCol>
                                      <CCol class="col-1 d-flex justify-content-center">
                                        <div class="align-fields d-flex" style="min-width: 0">
                                          <h5 class="mx-2 text-center" style="overflow-wrap: anywhere; min-width: 0" title="Locked: the customer cannot move, resize or rotate the logo">Locked</h5>
                                        </div>
                                      </CCol>
                                      <CCol class="col-1 d-flex justify-content-center"
                                        v-if="!style.is_fixed_logos_all">
                                        <div class="align-fields d-flex">
                                          <h5 class="mx-2">Default</h5>
                                        </div>
                                      </CCol>
                                    </div>
                                  </CRow>
                                </CCol>
                              </CRow>
                              <!-- Either ungrouped section Header ends -->

                              <CRow class="my-1" v-if="style.grouped_logos_info.ungrouped_logos.length > 0">
                                <ValidationObserver :ref="`observer-ungroup-${style_idx}`"
                                  class="d-flex align-items-center">
                                  <CCol class="col-12">
                                    <CRow v-for="(item, logoindex) in style.grouped_logos_info.ungrouped_logos"
                                      :key="'logo-' + logoindex" class="my-3">
                                      <div
                                        class="col-12 d-flex align-items-center rounded-lg py-3 border border-light-gray"
                                        :class="{ 'bg-light-gray': logoindex % 2 !== 0 }">
                                        <span class="remove-icon" v-if="Object.keys(style.grouped_logos_info.grouped_logos).length > 0 || 
                                          (Object.keys(style.grouped_logos_info.grouped_logos).length === 0 && logoindex !== 0)"
                                          @click="removeLogoPlacement(style_idx, logoindex, style.is_fixed_logos_all)">
                                          <BIconX />
                                        </span>
                                        <template>
                                          <!-- <ValidationObserver :ref="`observer-style-ungroup-${style_idx}-${item.id}`"
                                          class="d-flex align-items-center"> -->
                                          <CCol class="col-1">
                                            <validation-provider rules="" v-slot="{ errors }" name="Logo Image">
                                              <div class="image-holder flex-shrink-0"
                                                style="max-width:fit-content;width: 170px;"
                                                :class="errors && errors[0] ? 'v-image' : ''">
                                                <img v-if="item.logo_url == ''"
                                                  class="default-logo border border-secondary rounded-sm cursor-pointer w-100"
                                                  @click="setStyleFixedLogo(style_idx, logoindex, style.is_fixed_logos_all)"
                                                  src="../../assets/images/dummy-t.png" />
                                                <img v-else :key="`${item.logo_url}`"
                                                  class="selected_logo border border-secondary p-2 rounded-sm cursor-pointer w-100"
                                                  @click="setStyleFixedLogo(style_idx, logoindex, style.is_fixed_logos_all)"
                                                  :src="`${base_url}/${item.logo_url}`"
                                                  style="width:100%;height:100%" />
                                                <CInput addLabelClasses="required" placeholder="Logo Image"
                                                  type="hidden" v-model="item.logo_url"
                                                  :name="`fixed_logo_image_${style_idx}_${logoindex}`"
                                                  :id="`fixed_logo_image_${style_idx}_${logoindex}`">
                                                </CInput>
                                                <span class="error mt-1 d-block">{{ errors[0] }}</span>
                                              </div>
                                            </validation-provider>
                                          </CCol>
                                          <CCol class="col-4">
                                            <div class="align-fields d-flex">
                                              <validation-provider :rules="item.logo_url ? 'required' : ''" v-slot="{ errors }" name="Title">
                                                <CInput addLabelClasses="required" class="mr-2" placeholder="Title"
                                                  type="text" v-model="item.placement_title"
                                                  :name="`placement_title_${style_idx}_${logoindex}`"
                                                  :id="`placement_title_${style_idx}_${logoindex}`"
                                                  :class="errors && errors[0] ? 'v-error' : ''">
                                                </CInput>
                                                <span class="error mt-1 mr-2 d-block">{{ errors[0] }}</span>
                                              </validation-provider>
                                              <validation-provider :rules="item.logo_url ? 'required|decimal:5' : ''" v-slot="{ errors }"
                                                name="X">
                                                <CInput addLabelClasses="required" class="mr-2" placeholder="X"
                                                  type="text" v-model="item.x_axis"
                                                  :name="`logo_position_x_${style_idx}_${logoindex}`"
                                                  :id="`logo_position_x_${style_idx}_${logoindex}`"
                                                  :class="errors && errors[0] ? 'v-error' : ''">
                                                </CInput>
                                                <span class="error mt-1 mr-2 d-block">{{ errors[0] }}</span>
                                              </validation-provider>
                                              <validation-provider :rules="item.logo_url ? 'required|decimal:5' : ''" v-slot="{ errors }"
                                                name="Y">
                                                <CInput addLabelClasses="required" class="ml-2" placeholder="Y"
                                                  type="text" v-model="item.y_axis"
                                                  :name="`logo_position_y_${style_idx}_${logoindex}`"
                                                  :class="errors && errors[0] ? 'v-error' : ''"
                                                  :id="`logo_position_y_${logoindex}`">
                                                </CInput>
                                                <span class="error mt-1 ml-2 d-block">{{ errors[0] }}</span>
                                              </validation-provider>
                                            </div>
                                          </CCol>
                                          <CCol class="col-4">
                                            <div class="customize-setting-holder d-flex justify-content-between">
                                              <div class="rotate-logo-area">
                                                <validation-provider :rules="item.logo_url ? 'required|decimal:5' : ''" v-slot="{ errors }"
                                                  name="Rotation">
                                                  <CInput addLabelClasses="required" class="mr-2" placeholder="rot°"
                                                    type="text" v-model="item.rotation"
                                                    :name="`logo_rotate_${style_idx}_${logoindex}`"
                                                    :class="errors && errors[0] ? 'v-error' : ''"
                                                    :id="`logo_rotate_${style_idx}_${logoindex}`">
                                                  </CInput>
                                                  <span class="error mt-1 mr-2 d-block">{{ errors[0] }}</span>
                                                </validation-provider>
                                              </div>
                                              <validation-provider :rules="item.logo_url ? 'required|decimal:5' : ''" v-slot="{ errors }"
                                                name="Height">
                                                <CInput addLabelClasses="required" class="mx-2" placeholder="height"
                                                  type="text" v-model="item.height"
                                                  :name="`logo_height_${style_idx}_${logoindex}`"
                                                  :class="errors && errors[0] ? 'v-error' : ''"
                                                  :id="`logo_height_${style_idx}_${logoindex}`">
                                                </CInput>
                                                <span class="error mt-1 mx-2 d-block">{{ errors[0] }}</span>
                                              </validation-provider>
                                              <div class="shirt-side-area mx-2" style="width:100% ">
                                                <div class="dropdown_wrapper">
                                                  <validation-provider :rules="item.logo_url ? 'required' : ''" v-slot="{ errors }" name="Side">
                                                    <v-select :name="`logo_side_${style_idx}_${logoindex}`"
                                                      v-model="item.side" :options="sideOptions" placeholder="Front"
                                                      :class="errors && errors[0] ? 'v-error' : ''"
                                                      :id="`logo_side_${style_idx}_${logoindex}`"></v-select>
                                                    <span class="error mt-1 d-block">{{ errors[0] }}</span>
                                                  </validation-provider>
                                                </div>
                                              </div>
                                            </div>
                                          </CCol>
                                          <CCol class="col-1">
                                            <div class="align-fields gap-1 d-flex justify-content-center">
                                              <label class="custom-radio align-items-start">
                                                <span class="mt-3">
                                                  <input type="checkbox" :id="`fixed_logo_customizable_${logoindex}`"
                                                    :name="`logo_is_customizable_${style_idx}`"
                                                    v-model="item.is_customizable" />
                                                  <span class="radio_icon"></span>
                                                </span>
                                              </label>
                                            </div>
                                          </CCol>
                                          <CCol class="col-1">
                                            <div class="align-fields gap-1 d-flex justify-content-center">
                                              <!-- AB#22275: unticked = the customer may move, resize and rotate this logo (recolouring is the Customizable box) -->
                                              <label class="custom-radio align-items-start"
                                                title="Locked: the customer cannot move, resize or rotate this logo. Untick to let them.">
                                                <span class="mt-3">
                                                  <input type="checkbox" :id="`fixed_logo_locked_${style_idx}_${logoindex}`" :name="`logo_is_locked_${style_idx}`"
                                                    v-model="item.is_locked" />
                                                  <span class="radio_icon"></span>
                                                </span>
                                              </label>
                                            </div>
                                          </CCol>
                                          <CCol class="col-1 d-flex justify-content-center">
                                            <div class="align-fields gap-1 d-flex">
                                              <label class="custom-radio align-items-start"
                                                v-if="!style.is_fixed_logos_all">
                                                <span class="mt-3">
                                                  <input type="radio" :id="`fixed_logo_default_${logoindex}`"
                                                    :name="`logo_is_default_${style_idx}`" :value="true"
                                                    v-model="item.is_default"
                                                    @change="handleDefault($event, style_idx, logoindex)" />
                                                  <span class="radio_icon"></span>
                                                </span>
                                              </label>
                                              <b-button variant="primary" size="sm"
                                                v-if="logoindex === 0 && style.fixed_logos.length <= 1"
                                                @click.prevent="clearLogoPlacement(style_idx, logoindex)"
                                                class="ml-2 align-self-center">Clear</b-button>
                                            </div>
                                          </CCol>
                                          <!-- </ValidationObserver> -->
                                        </template>
                                      </div>

                                    </CRow>

                                  </CCol>
                                </ValidationObserver>
                              </CRow>
                              <CRow>
                                <CCol class="col-12">
                                  <div class="d-flex justify-content-end">
                                    <b-button @click="AddLogoPlacement(style_idx, style.is_fixed_logos_all)"
                                      class="btn-add-fields mt-3">
                                      <BIconPlus />
                                    </b-button>
                                  </div>
                                </CCol>
                              </CRow>

                            </template>
                            <!--  Ungrouped logos ends-->
                          </template>
                          <!-- Either section end-->
                        </b-card-text>
                      </b-tab>
                    </b-tabs>
                  </template>
                  <div v-else class="alert alert-danger">No style exist against this product</div>
                </CCol>
              </CRow>
              <div class="d-flex justify-content-between align-items-center mt-3">
                <div></div>
                <div class="d-flex gap-2">
                  <b-button @click="saveCompanyFields" variant="primary">Save</b-button>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>
        <b-tab title="Bind Variants" v-if="company && company.platform == 'shopify'">
          <SizeVariantsMapping :product_fields="product_fields" />
        </b-tab>

      </b-tabs>
    </b-card>

    <b-modal id="setStyleFixedLogo" size="lg" no-close-on-backdrop hide-footer>
      <template #modal-title>
        <span>File Manager</span>
      </template>
      <!--          <ValidationProvider rules="required" v-slot="{ errors }">-->
      <asset-selector :selectedImage="addStyleFixedLogo" :fileType="'fixed_logo'"></asset-selector>
      <!--          </ValidationProvider>-->

    </b-modal>

    <b-modal id="addonSearchProductsModal" size="lg" no-close-on-backdrop>
      <template #modal-title>
        <span>Sync Addon's</span>
      </template>
      <div class="row mt-2">
        <div class="col-12">
          <div class="row">
            <div class="col-md-12 my-2">
              <b-form-group id="assign_factory" label-for="assign_factory">

                <b-input-group prepend="Search Addon's" class="mt-3">
                  <b-form-input label="addon_search_term" type="text" name="addon_search_term"
                    v-model="addon_search_term" placeholder="Search addon's by title for syncing"></b-form-input>
                  <b-input-group-append>
                    <b-button variant="info" @click="searchProductsForAddon">Search</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              <ul>
                <template v-if="company && isEcommercePlatform">
                  <li style="padding: 10px" v-for="(addon_product, index) in addon_search_products"
                    :key="addon_product.product_id">
                    <span> <img v-if="addon_product.product_image"
                        :src="addon_product.product_image" width="50" height="50" /> </span>
                    <span style="margin-left: 5px">{{ addon_product.product_name }}</span>
                    <span style="margin-left: 15px"><button
                        @click="selectAddonSearchedProduct(index)">Select</button></span>
                  </li>
                </template>
              </ul>
            </div>
          </div>
        </div>
      </div>

    </b-modal>

    <!-- Either section Grouping modal starts-->
    <template>
      <div>
        <b-modal id="add-edit-groups-modal" size="md" hide-footer @hide="handleAddEditGroupModalHideEvent"
          :title="isGroupEditMode ? 'Edit Group' : 'Create New Group'">
          <ValidationObserver ref="groupValidationObserver" v-slot="{ invalid }">
            <div>
              <div>
                <label for="new-group-name" class="required">Group Name</label>
                <b-form-group>
                  <ValidationProvider ref="groupNameProvider" name="Group Name" rules="required"
                    v-slot="{ errors, validate }">
                    <b-form-input name="newGroupName" id="new-group-name" v-model="add_edit_group_info_obj.group_name"
                      placeholder="Enter group name" @input="{ { validate } }"></b-form-input>
                    <span class="text-danger">
                      <span>{{ errors[0] }}</span>
                    </span>
                  </ValidationProvider>
                </b-form-group>
              </div>
              
              <div>
                <label class="required mt-2">Select Existing Logos</label>
                <!-- <div class="dropdown_wrapper"> -->
                <b-form-group>
                  <ValidationProvider name="Group Logos" rules="required" v-slot="{ errors }">
                    <v-select label="placement_title" inputId="temp_id" multiple
                      v-model="add_edit_group_info_obj.selected_logos"
                      :options="add_edit_group_modal_options"
                      placeholder="Select a logo">
                    </v-select>
                    <span class="text-danger">
                      <span>{{ errors[0] }}</span>
                    </span>
                  </ValidationProvider>
                </b-form-group>
              </div>

              <b-button variant="primary" class="mt-3" :disabled="invalid"
                @click="createOrUpdateLogosGroup()">
                {{ isGroupEditMode ? 'Update' : 'Save' }}
              </b-button>
            </div>
          </ValidationObserver>
        </b-modal>
      </div>
    </template>
    <!-- Grouping modal ends-->

  </div>
</template>
<script>
import { http } from "@/config/httpCommon";
import { checkIsEmpty, getRandom, isEcommercePlatform, santaClone } from "@/helpers/Helpers";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Vue from 'vue';
import "vue-select/dist/vue-select.css";
import SizeVariantsMapping from "../products/SizeVariantsMapping.vue";

const default_fixed_logo_obj = {
  id: '',
  placement_title: '',
  x_axis: '',
  y_axis: '',
  rotation: '',
  logo_url: '',
  width: '',
  height: '',
  file_id: '',
  side: { id: 'front', label: 'Front' },
  is_default: false,
  is_customizable: false,
  // AB#22275: new placements start locked, like every fixed logo before the flag existed
  is_locked: true,
  style_id: null
};

const custom_sku_obj = {
  title: "",
  is_custom_title: false,
  current_title: "",
  description: "",
  is_custom_description: false,
  moq: 0,
  moq_type: null,
  is_custom_moq: false,
  size_chart: "",
  is_custom_size_chart: false,
  size_reference: "",
  is_custom_size_reference: false,
  prices: [],
  is_custom_prices: false,
  is_custom_addons: false,
};

const default_sku_obj = {
  title: "",
  description: "",
  moq: 0,
  moq_type: "by_design",
  size_chart: "",
  size_reference: "",
  prices: []
}
export default {
  props: ['id'],
  components: {
    ValidationObserver,
    ValidationProvider,
    SizeVariantsMapping
  },
  async created() {
    // logo styles
    this.product_styles = [];
    await this.$store.commit('set', ['showLoader', true]);
    await this.fetchProductStyleList();

    //getCompanyFields
    await this.$store.dispatch('defaultCategories');
    let categories = this.$store.getters.getDefaultCategories;
    this.categories = [];
    categories.forEach(element => {
      this.categories.push({
        value: element.id,
        label: element.category_name,
        subcategories: element.subcategories
      })
    });

    if (this.id) {
      
      let res = await this.$store.dispatch('getDefaultProductFields', this.id);
      if (res.data.data) {
        this.product_fields = res.data.data;
        let saved_categories = res.data.data.categories;
        for (let cat = 0; cat < saved_categories.length; cat++) {
          this.form.category_ids.push({
            value: saved_categories[cat].id,
            label: saved_categories[cat].category_name,
            parent_id: saved_categories[cat].parent_id,
            subcategories: saved_categories[cat].subcategories
          })
        }
     
      }else{
        this.showToast("Product Not Found", "error");
        this.$router.push('/default-products');
      }
    }

    this.addValidationRules();
    this.$store.commit('set', ['showLoader', false]);
    this.company = this.$store.getters.company;
  },
  destroyed() {
    this.form.custom_skus = custom_sku_obj;
    this.form.default_skus = default_sku_obj;
  },
  data() {
    return {
      showMessage: null,
      company: null,
      dirty_styles: [],
      moq_types: [
        { id: "by_design", label: "By Design" },
        { id: "by_cart", label: "By Cart" },
      ],
      edit_file: null,
      edit_file_url: '',
      currencies: [],
      custom_currencies: [],
      show_price_visibilty: false,
      form: {
        category_ids: [],
        subCategory_ids: [],
        default_skus: default_sku_obj,
        custom_skus: custom_sku_obj,
      },
      categories: [],
      settings_currency: {},
      settings_moq: {},
      company_currency_code: null,
      product_styles: [],
      delete_fixed_logos: [],
      base_url: process.env.VUE_APP_FILE_URL,
      sides: [
        { id: 'front', label: 'Front' },
        { id: 'back', label: 'Back' },
      ],
      is_reversible: false,
      error_messages: {
        custom: {
          product_category: {
            required: 'Category field is required'
          },
          title: {
            required: 'Title field is required'
          },
          description: {
            required: 'Description field is required'
          },
          moq: {
            required: 'MOQ field is required'
          },
          moq_type: {
            required: 'MOQ type field is required'
          },
          size_reference: {
            required: 'Size Reference field is required'
          },
          price: {
            required: 'Price field is required'
          },
        }
      },
      addons: {
        default: [],
        custom: []
      },
      addon_search_products: [],
      addon_search_term: '',
      current_addon_id: '',
      is_ecommerce_product: false,
      product_fields: null,
      newGroupName: '',
      selectedGroupLogos: [],
      editGroupObject: null,
      ungroupedLogosOptions: [],
      isGroupEditMode: false, // true for editing, false for creating a new group
      defaultGroupId: null,
      removedDefaultGroupId: null,
      styles: [],
      allLogosDisplayActive: false,
      // activeDisplayLogos:[],
      selectedOption: '',
      style: {
        grouped_logos_info: {
          grouped_logos: {}, // Replace with your grouped logo data
          ungrouped_logos: [] // Replace with your ungrouped logo data
        },
        logo: [] // Replace with your all logos array
      },
      is_all_tab: false,
      either_tab_logo_upload_info: {
        style_index: -1, group_name: null, logo_index: -1
      },
      active_style_index: 0,
      add_edit_group_info_obj: {
        group_name: '',
        selected_logos: []
      },
      add_edit_group_modal_options: []
    }
  },
  watch: {
    selectedOption(newValue) {
      this.getStyleAllLogoState(this.style); // Call function when it changes
    }
  },
  computed: {
    // Reversible products (AB#19064/AB#19680): four-way placement options;
    // normalizeLogoSideForSave() splits the option back into side + face.
    sideOptions() {
      if (!this.is_reversible) {
        return this.sides;
      }
      return [
        { id: 'front', label: 'Front (outside)' },
        { id: 'back', label: 'Back (outside)' },
        { id: 'front-inside', label: 'Front (inside)' },
        { id: 'back-inside', label: 'Back (inside)' },
      ];
    },
    editFileUrl: {
      get() {
        return this.edit_file_url;
      },
      set(value) {
        this.edit_file_url = value;
      }
    },
    formattedCategories() {
      const formatted = [];
      this.categories.forEach(category => {
        if (category.subcategories && category.subcategories.length > 0) {
          category.subcategories.forEach(subCategory => {
            formatted.push({
              value: subCategory.id,
              label: `${category.label} > ${subCategory.category_name}`,
            });
          });
        } else {
          formatted.push({
            value: category.value,
            label: category.label,
          });
        }
      });
      return formatted;
    },
    // Active ungrouped logos based on selectedOption
    activeDisplayLogos() {
      return this.selectedOption === "either"
        ? this.style.grouped_logos_info.ungrouped_logos
        : this.style.logo;
    },
  },
  methods: {
    isEcommercePlatform,
    showCreateGroupModal() {
      const active_style = this.product_styles[this.active_style_index];
      this.add_edit_group_modal_options = active_style.grouped_logos_info.ungrouped_logos
      this.$bvModal.show('add-edit-groups-modal');
    },
    getAddEditGroupInfoObject(set_default_object = false) {
      let default_obj = {
        group_name: '',
        selected_logos: []
      }
      if (set_default_object) {
        this.add_edit_group_info_obj = default_obj
      }
    },
    isEmptyFixedLogo(logo) {
      return (
        !logo.logo_url &&
        !logo.placement_title &&
        !logo.x_axis &&
        !logo.y_axis &&
        !logo.rotation &&
        !logo.height
      );
    },
    getGroupDefaultObject(updated_values = {}) {
      return {
        ...{ id: null, company_id: null, is_default: false, logos: [], style_id: null, title: null }, ...updated_values
      }
    },
    handleDefault(event, style_idx, logo_index, group_name = null) {
      const style = this.product_styles[style_idx];
      if (group_name) {
        for (let style_group_name in style.grouped_logos_info.grouped_logos) {
          if (style_group_name != group_name) {
            style.grouped_logos_info.grouped_logos[style_group_name].is_default = false
          }
        }
        style.grouped_logos_info.ungrouped_logos.forEach(ungrouped_logo => {
          ungrouped_logo.is_default = false
        })
      } else {
        for (let style_group_name in style.grouped_logos_info.grouped_logos) {
          style.grouped_logos_info.grouped_logos[style_group_name].is_default = false
        }

        // assign and unassign default from ungrouped logos
        style.grouped_logos_info.ungrouped_logos.forEach((ungrouped_logo, index) => {
          ungrouped_logo.is_default = false;
        });

        let default_ungrouped_logo = style.grouped_logos_info.ungrouped_logos[logo_index];
        default_ungrouped_logo.is_default = true;
      }

    },
    async isAtleastOneDefaultValidation() {
      let isAtleastOneDefault = false;
      let isDefaultArray = [];
      for (const style of this.product_styles) {
        let countIsDefault = 0;
        for (const logo of style.fixed_logos) {
          if (!style.is_fixed_logos_all && (logo.is_default === 1 || logo.is_default)) {
            countIsDefault++
          }
        }
        for (const group of Object.values(style.grouped_logos_info.grouped_logos)) {
          if (!style.is_fixed_logos_all && (group.is_default === 1 || group.is_default)) {
            countIsDefault++;
          }
        }
        for (const logo of style.grouped_logos_info.ungrouped_logos) {
          if (!style.is_fixed_logos_all && (logo.is_default === 1 || logo.is_default)) {
            countIsDefault++
          }
        }
        if (!style.is_fixed_logos_all && countIsDefault === 0) {
          isDefaultArray.push(`Please mark atleast one fixed logo as default in the ${style.tab_title}`);
        }
        else if (!style.is_fixed_logos_all && countIsDefault > 1) {
          isDefaultArray.push(`Please mark only one fixed logo as default in the ${style.tab_title}`);
        }
      }
      isDefaultArray.forEach((is_default) => {
        this.showToast(is_default)
      })
      if (isDefaultArray.length > 0) {
        isAtleastOneDefault = false;
      }
      else {
        isAtleastOneDefault = true;
      }
      return isAtleastOneDefault;
    },
    async stylefixedLogoDirtyValidation() {
      this.dirty_styles = [];
      let allFixedLogoValidation = true;
      for (const [styleIndex, style] of this.product_styles.entries()) {
        for (const [logoIndex, logo] of style.fixed_logos.entries()) {
          if (style.fixed_logos.length > 1) {
            this.dirty_styles.push(`observer-style-${styleIndex}-${logoIndex}`);
          }
          else {
            for (const property in logo) {
              if (logoIndex === 0 && property !== 'side' && property !== 'is_default' && property !== 'id' && property != 'is_customizable' && property != 'is_locked' && logo[property] !== '') {
                this.dirty_styles.push(`observer-style-${styleIndex}-${logoIndex}`);
                break;
              }
            }
          }
        }
      }
      for (const dirty_style of this.dirty_styles) {
        if (this.$refs[dirty_style] && this.$refs[dirty_style][0]) {
          let validate = await this.$refs[dirty_style][0].validate();
          if (!validate) {
            allFixedLogoValidation = false;
          }
        }
      }
      return allFixedLogoValidation
    },
    updateDefaultValues() {
      for (const [styleIndex, style] of this.product_styles.entries()) {
        let countIsDefaultLogo = 0;
        for (const logo of style.fixed_logos) {
          if (logo.is_default === 1) {
            countIsDefaultLogo++;
          }
        }
        this.product_styles[styleIndex].fixed_logos.map((fixed_logo) => {
          if (countIsDefaultLogo > 1 && fixed_logo.is_default === 1) {
            fixed_logo.is_default = false
            countIsDefaultLogo--
          } else {
            fixed_logo.is_default = fixed_logo.is_default === 1
          }
          fixed_logo.is_customizable = fixed_logo.is_customizable === 1
          // AB#22275: only an explicit false/0 unlocks; a missing flag stays locked
          fixed_logo.is_locked = !(fixed_logo.is_locked === false || fixed_logo.is_locked === 0)
          return fixed_logo
        })
      }
    },
    addValidationRules() {
      this.$validator.localize('en', this.error_messages);
    },
    async saveCompanyFields() {
      
      this.addValidationRules()

      // Either tab validation
      if (!this.style.is_fixed_logos_all) {
        let eitherTabValidation = await this.validateEitherTab();
        if (!eitherTabValidation) {
          return;  // Stop if validation fails
        }
      }

      let valid = await this.$validator.validate();

      let fixed_logo_validate = await this.stylefixedLogoDirtyValidation();
      let validate_default = true;

      validate_default = await this.isAtleastOneDefaultValidation();

      if (validate_default && fixed_logo_validate && valid) {

        try {
          let formData = new FormData();
          formData.append('product_id', this.id);
          let category_ids = [];
          if (this.form.category_ids.length > 0) {
            for (let i = 0; i < this.form.category_ids.length; i++) {
              formData.append('category_ids[]', this.form.category_ids[i].value);
            }
          }
          if (this.form.subCategory_ids.length > 0) {
            for (let i = 0; i < this.form.subCategory_ids.length; i++) {
              formData.append('category_ids[]', this.form.subCategory_ids[i].value);
            }
          }

          if (this.form.custom_skus.is_custom_title === true || this.form.custom_skus.is_custom_title === 'true') {
            this.form.custom_skus.current_title = this.form.custom_skus.title;
          }
          else {
            this.form.custom_skus.current_title = this.form.default_skus.title;
          }
          if (this.form.custom_skus.is_custom_moq === true || this.form.custom_skus.is_custom_title === 'true') {
            this.form.custom_skus.moq = this.form.custom_skus.moq ? this.form.custom_skus.moq : 0;
            this.form.custom_skus.moq_type = this.form.custom_skus.moq_type.id ? this.form.custom_skus.moq_type.id : this.form.custom_skus.moq_type;
          } else {
            this.form.custom_skus.moq = 0;
            this.form.custom_skus.moq_type = 'by_design';
          }
          if ((this.form.custom_skus.is_custom_prices === false || this.form.custom_skus.is_custom_prices === 'false') && this.form.custom_skus.prices.length === 0) {
            this.form.custom_skus.prices = [];
          }
          formData.append('custom_skus', JSON.stringify(this.form.custom_skus));
          if (this.form.custom_skus.is_custom_addons) {
            formData.append('addons', JSON.stringify(this.addons.custom));
          }
          formData.append('file', this.edit_file);

          this.submitForm(formData);
        } catch (err) {
          this.showError(err);
        }

      } else {
        this.showToast("Please fill all required fields", "error");
      }
    },
    async submitForm(form_data) {

      this.$store.commit('set', ['showLoader', true]);
      this.submitFixedLogos();
      this.$store.commit('set', ['showLoader', false]);

      this.showToast('Product has been saved successfully', 'SUCCESS')
      this.$router.push('/default-products');

    },
    // Reversible products (AB#19680): map a stored side ('front'/'back' string
    // or option object) + face onto the four-way select option.
    sideOptionFor(side, face) {
      const raw = typeof side === 'string' ? side : (side && side.id) || 'front';
      const base = String(raw).toLowerCase().replace('-inside', '') === 'back' ? 'back' : 'front';
      const optId = (face === 'inside' || String(raw).endsWith('-inside')) ? `${base}-inside` : base;
      return this.sideOptions.find(opt => opt.id === optId)
        || { id: base, label: base === 'front' ? 'Front' : 'Back' };
    },
    // The backend stores side from the option LABEL, so four-way labels must
    // never reach it — split the option into a clean side object + face key.
    normalizeLogoSideForSave(logo) {
      const optId = String((logo.side && logo.side.id) || logo.side || 'front');
      const base = optId.replace('-inside', '') === 'back' ? 'back' : 'front';
      return {
        ...logo,
        side: { id: base, label: base === 'front' ? 'Front' : 'Back' },
        face: optId.endsWith('-inside') ? 'inside' : 'outside',
      };
    },
    async submitFixedLogos() {

  let category_ids = [];

  if (this.form.category_ids.length > 0) {
    this.form.category_ids.forEach(cat => category_ids.push(cat.value));
  }

  if (this.form.subCategory_ids.length > 0) {
    this.form.subCategory_ids.forEach(cat => category_ids.push(cat.value));
  }

  const payload = {
    product_styles: this.product_styles.map(style => ({
      ...style,

      fixed_logos: style.fixed_logos.filter(
        logo => !this.isEmptyFixedLogo(logo)
      ).map(this.normalizeLogoSideForSave),

      grouped_logos_info: {
        ...style.grouped_logos_info,

        grouped_logos: Object.fromEntries(
          Object.entries(style.grouped_logos_info.grouped_logos || {}).map(([title, group]) => [
            title,
            { ...group, logos: (group.logos || []).map(this.normalizeLogoSideForSave) },
          ])
        ),

        ungrouped_logos: style.grouped_logos_info.ungrouped_logos.filter(
          logo => !this.isEmptyFixedLogo(logo)
        ).map(this.normalizeLogoSideForSave)
      }
    })),

    product_id: this.id,
    defaultGroupId: this.defaultGroupId,
    removedDefaultGroupId: this.removedDefaultGroupId,
    delete_fixed_logos: JSON.stringify(this.delete_fixed_logos),
    category_ids
  };

  await http.post(`mark/product/default`, payload);
},

    async oldsubmitFixedLogos() {


       let category_ids = [];
          if (this.form.category_ids.length > 0) {
            for (let i = 0; i < this.form.category_ids.length; i++) {
              category_ids.push(this.form.category_ids[i].value);
            }
          }
          if (this.form.subCategory_ids.length > 0) {
            for (let i = 0; i < this.form.subCategory_ids.length; i++) {
              category_ids.push(this.form.subCategory_ids[i].value);
            }
          }

      const payload = {
        product_styles: this.product_styles.map(style => ({
          ...style,
          fixed_logos: style.fixed_logos.filter(logo => logo.logo_url?.trim()),
          grouped_logos_info: {
            ...style.grouped_logos_info,
            ungrouped_logos: style.grouped_logos_info.ungrouped_logos.filter(logo => logo.logo_url?.trim())
          }
        })),
        product_id: this.id,
        defaultGroupId: this.defaultGroupId,
        removedDefaultGroupId: this.removedDefaultGroupId,
        delete_fixed_logos: JSON.stringify(this.delete_fixed_logos),
        category_ids: category_ids
      };

      await http.post(`mark/product/default`, payload);
    },
    setStyleFixedLogo(styleIndex, fixedLogoIndex, is_all_tab = true, group_name = null) {
      if (!is_all_tab) {
        this.either_tab_logo_upload_info = {
          style_index: styleIndex, group_name, logo_index: fixedLogoIndex
        }
      } else {
        this.style_index = styleIndex;
        this.fixed_logo_index = fixedLogoIndex;
      }
      this.$bvModal.show('setStyleFixedLogo');
    },
    addStyleFixedLogo(selectedLogo) {
      const style_tab_info = this.either_tab_logo_upload_info
      if (style_tab_info.style_index == -1) {
        this.product_styles[this.style_index].fixed_logos[this.fixed_logo_index].logo_url = selectedLogo.file_url;
        this.product_styles[this.style_index].fixed_logos[this.fixed_logo_index].file_id = selectedLogo.id;
      } else {
        if (this.either_tab_logo_upload_info.group_name) {
          const grouped_logo = this.product_styles[style_tab_info.style_index].grouped_logos_info.grouped_logos[style_tab_info.group_name].logos[style_tab_info.logo_index]
          grouped_logo.logo_url = selectedLogo.file_url
          grouped_logo.file_id = selectedLogo.id
          if (grouped_logo.file) {
            grouped_logo.file.file_url = selectedLogo.file_url
          }
          this.$set(
            this.product_styles[style_tab_info.style_index].grouped_logos_info.grouped_logos[style_tab_info.group_name].logos,
            style_tab_info.logo_index,
            grouped_logo
          );
        } else {
          this.$set(this.product_styles[style_tab_info.style_index].grouped_logos_info.ungrouped_logos[style_tab_info.logo_index], 'logo_url', selectedLogo.file_url)
          // this.product_styles[style_tab_info.style_index].grouped_logos_info.ungrouped_logos[style_tab_info.logo_index] =  
          // Object.assign({}, this.product_styles[style_tab_info.style_index].grouped_logos_info.ungrouped_logos[style_tab_info.logo_index], {logo_url: selectedLogo.file_url})
          this.product_styles[style_tab_info.style_index].grouped_logos_info.ungrouped_logos[style_tab_info.logo_index].file_id = selectedLogo.id
        }
      }

      if (this.errors.first(`fixed_logo_image_1${this.style_index}`) && style_tab_info.style_index == -1) {
        for (let i = 0; i < this.errors.items.length; i++) {
          if (this.errors.items[i].field === `fixed_logo_image_1${this.style_index}`) {
            this.errors.items.splice(i, 1);
          }
        }
      }
      this.$bvModal.hide('setStyleFixedLogo');
      this.either_tab_logo_upload_info = {
        style_index: -1, group_name: null, logo_index: -1
      }
    },

    mapDefaultSKU(default_sku_response) {
      let temp_default_sku_obj = null;
      if (default_sku_response) {
        temp_default_sku_obj = default_sku_response;
        temp_default_sku_obj.title = default_sku_response.sku_id;
        temp_default_sku_obj.description = default_sku_response.description;
        temp_default_sku_obj.moq = default_sku_response.minimum_order_quantity;
        temp_default_sku_obj.moq_type = this.moq_types.find((type) => type.id === default_sku_response.minimum_order_quantity_type);
        temp_default_sku_obj.size_chart = default_sku_response.image_url;
        temp_default_sku_obj.size_reference = default_sku_response.sizechart_reference;
        let default_sku_prices = default_sku_response && default_sku_response.skucurrency.length > 0 ? default_sku_response.skucurrency : [];
        temp_default_sku_obj.prices = this.getCumulativeArray(this.currencies, default_sku_prices);
      }
      else {
        temp_default_sku_obj = default_sku_obj
        let default_sku_prices = [];
        temp_default_sku_obj.prices = this.getCumulativeArray(this.currencies, default_sku_prices);
      }
      return temp_default_sku_obj;
    },
    mapCustomSKU(custom_sku, default_skus) {
      let temp_custom_sku_obj = null;
      if (custom_sku) {
        temp_custom_sku_obj = custom_sku;
        temp_custom_sku_obj.title = custom_sku.title;
        temp_custom_sku_obj.is_custom_title = custom_sku.is_custom_title
        temp_custom_sku_obj.description = custom_sku.description;
        temp_custom_sku_obj.is_custom_description = custom_sku.is_custom_description
        temp_custom_sku_obj.moq = custom_sku.moq;
        temp_custom_sku_obj.moq_type = custom_sku.moq_type;
        temp_custom_sku_obj.is_custom_moq = custom_sku.is_custom_moq
        temp_custom_sku_obj.size_chart = custom_sku.size_chart;
        if (temp_custom_sku_obj.size_chart) {
          this.edit_file_url = this.base_url + '/' + temp_custom_sku_obj.size_chart;
        }
        else {
          this.edit_file_url = null;
        }
        temp_custom_sku_obj.is_custom_size_chart = custom_sku.is_custom_size_chart
        temp_custom_sku_obj.size_reference = custom_sku.size_reference;
        temp_custom_sku_obj.is_custom_size_reference = custom_sku.is_custom_size_reference
        temp_custom_sku_obj.is_custom_prices = custom_sku.is_custom_prices
        temp_custom_sku_obj.is_custom_addons = custom_sku.is_custom_addons ? custom_sku.is_custom_addons : false;
        let custom_sku_prices = custom_sku && custom_sku.prices.length > 0 ? custom_sku.prices : [];
        temp_custom_sku_obj.prices = this.getCumulativeArray(this.currencies, custom_sku_prices);

      } else {
        temp_custom_sku_obj = custom_sku_obj;
        let default_skus_prices = default_skus && default_skus.skucurrency.length > 0 ? default_skus.skucurrency : [];
        temp_custom_sku_obj.prices = this.getCumulativeArray(this.currencies, default_skus_prices);
      }
      return temp_custom_sku_obj;
    },
    getCumulativeArray(currencies, user_currency) {

      if (!user_currency && user_currency.length === 0) {
        return currencies
      }
      if (!currencies && !Array.isArray(currencies) && currencies.length === 0) {
        return [];
      }

      // Convert user_currency array to a map for easier lookup
      const userCurrencyMap = new Map();
      for (const item of user_currency) {
        if (Object.prototype.hasOwnProperty.call(item, "pivot")) {
          const { code, pivot } = item;
          userCurrencyMap.set(code, pivot.price);
        }
        else {
          const { code, price } = item;
          userCurrencyMap.set(code, price);
        }

      }
      const cumulativeArray = [];
      for (const currency of currencies) {
        const { code } = currency;
        const price = userCurrencyMap.has(code) ? userCurrencyMap.get(code) : null;
        cumulativeArray.push({ ...currency, price });
      }
      // Filter cumulativeArray to include only objects with code values in setting_array
      if (this.settings_currency && this.settings_currency.currencies && this.settings_currency.visible) {
        const filteredArray = cumulativeArray.filter((currency) => this.settings_currency.currencies.includes(currency.code));
        return filteredArray;
      }

      return [];
    },
    AddLogoPlacement(style_index,is_all_tab = true) {
      const default_obj = Object.assign({}, default_fixed_logo_obj);
      default_obj.style_id = this.product_styles[style_index].style_id
      if (is_all_tab) {
        this.product_styles[style_index].fixed_logos.push(default_obj);
      } else {
        default_obj.id = getRandom(10, "alphe_numeric").toString()
        this.product_styles[style_index].grouped_logos_info.ungrouped_logos.push(default_obj);
      }
    },
    removeLogoPlacement(style_index, logo_index, is_all_tab = true) {
      let remove_logo = null
      if (is_all_tab) {
        remove_logo = this.product_styles[style_index].fixed_logos.splice(logo_index, 1);
      }
      else {
        remove_logo = this.product_styles[style_index].grouped_logos_info.ungrouped_logos.splice(logo_index, 1)
      }
      remove_logo = remove_logo[0]
      if (remove_logo && remove_logo.id) {
        const foundIndex = this.delete_fixed_logos.findIndex(item => item.id === remove_logo.id);
        if (foundIndex === -1) {
          // If the item doesn't exist in the array, push it
          this.delete_fixed_logos.push(remove_logo);
        }
      }

    },
    clearLogoPlacement(style_index, logo_index) {
      let tab_value = this.product_styles[style_index].is_fixed_logos_all;
      // All tab working
      if(tab_value) {
        //Logo is added to the database but now we want to remove it
        if (Object.prototype.hasOwnProperty.call(this.product_styles[style_index].fixed_logos[logo_index], 'id') && this.product_styles[style_index].fixed_logos[logo_index].id !== '') {
          const removedLogo = this.product_styles[style_index].fixed_logos[logo_index];
          const foundIndex = this.delete_fixed_logos.findIndex(item => item.id === removedLogo.id);
          if (foundIndex === -1) {
            // If the item doesn't exist in the array, push it
            this.delete_fixed_logos.push(removedLogo);
          }
          Vue.set(this.product_styles[style_index].fixed_logos, logo_index, { ...default_fixed_logo_obj, is_default: false });
          this.$refs[`observer-style-${style_index}-${logo_index}`][0].reset();

        }
        else {
          Vue.set(this.product_styles[style_index].fixed_logos, logo_index, { ...default_fixed_logo_obj, is_default: false });
          this.$refs[`observer-style-${style_index}-${logo_index}`][0].reset();
        }
      } else {
        // Either Tab working
        //Logo is added to the database but now we want to remove it
        if (Object.prototype.hasOwnProperty.call(this.product_styles[style_index].grouped_logos_info.ungrouped_logos[logo_index], 'id') && this.product_styles[style_index].grouped_logos_info.ungrouped_logos[logo_index].id !== '') {
          const removedLogo = this.product_styles[style_index].grouped_logos_info.ungrouped_logos[logo_index];
          const foundIndex = this.delete_fixed_logos.findIndex(item => item.id === removedLogo.id);
          if (foundIndex === -1) {
            // If the item doesn't exist in the array, push it
            this.delete_fixed_logos.push(removedLogo);
          }
          Vue.set(this.product_styles[style_index].grouped_logos_info.ungrouped_logos, logo_index, { ...default_fixed_logo_obj, is_default: true });
          if(this.$refs[`observer-ungroup-${style_index}`]) {
          this.$refs[`observer-ungroup-${style_index}`][0].reset();
          }
        }
        else {
          Vue.set(this.product_styles[style_index].grouped_logos_info.ungrouped_logos, logo_index, { ...default_fixed_logo_obj, is_default: true });
          if(this.$refs[`observer-ungroup-${style_index}`]) {
            this.$refs[`observer-ungroup-${style_index}`][0].reset();
          }
        }
      }
    },
    replicateToAllStyles(copy_style_index) {
      const copy_from_style = santaClone(this.product_styles[copy_style_index])
      //replicate all tab starts
      const fixed_logos = copy_from_style.fixed_logos.map((fixed_logo, fixedLogoIndex) => {
        fixed_logo.id = null
        return fixed_logo
      })
      //replicate all tab ends
      
      //replicate either tab starts
      let copy_style_grouped_logo_info = copy_from_style.grouped_logos_info
      for (const group_name in copy_style_grouped_logo_info.grouped_logos) {
        copy_style_grouped_logo_info.grouped_logos[group_name].id = null
        let group_logos = copy_style_grouped_logo_info.grouped_logos[group_name].logos
        
        group_logos = group_logos.map((group_logo, groupLogoIndex) => {
          group_logo.id = null
          group_logo.fixed_logo_group_id = null
          group_logo.group = null
          return group_logo;
        })
        copy_style_grouped_logo_info.grouped_logos[group_name].logos = group_logos
      }

      copy_style_grouped_logo_info.ungrouped_logos = copy_style_grouped_logo_info.ungrouped_logos.map((ungrouped_logo, ungroupedLogoIndex) => {
        ungrouped_logo.id = null
        return ungrouped_logo
      })

      this.product_styles.forEach((product_style, productStyleIndex) => {
        if (productStyleIndex != copy_style_index) {
          product_style.is_fixed_logos_all = copy_from_style.is_fixed_logos_all

          let style_groups = copy_style_grouped_logo_info.grouped_logos;
          let style_ungroup_logos = copy_style_grouped_logo_info.ungrouped_logos;

          // update style id for each style groups and its logos
          for (const group_name in style_groups) {
            const group = style_groups[group_name]
            group.style_id = product_style.style_id

            let group_logos = style_groups[group_name].logos;

            group_logos = group_logos.map((group_logo, groupLogoIndex) => {
              group_logo.style_id = product_style.style_id
              return group_logo;
            })
            style_groups[group_name].logos = group_logos
          }

          // update style id for each ungroup logo
          copy_style_grouped_logo_info.ungrouped_logos = copy_style_grouped_logo_info.ungrouped_logos.map((ungrouped_logo, ungroupedLogoIndex) => {
            ungrouped_logo.style_id = product_style.style_id
            return ungrouped_logo
          })

          product_style.grouped_logos_info = santaClone(copy_style_grouped_logo_info)

          product_style.fixed_logos = santaClone(fixed_logos)
        }
      })
      //replicate either tab ends
    },

    syncAddons(addon_id) {
      this.addon_search_products = [];
      this.addon_search_term = '';
      this.current_addon_id = addon_id;
      this.$bvModal.show('addonSearchProductsModal');
    },
    async searchProductsForAddon() {

      if (this.addon_search_term.length < 3) {
        this.showToast('Please type at least 3 charcters');
      } else {
        this.addon_search_products = [];
        await this.$store.commit('set', ['showLoader', true]);
        let payload = { search_term: this.addon_search_term }
        try {
          let res = await http.post("addon/search", payload);
          res = JSON.parse(JSON.stringify(res));
          this.addon_search_products = res.data;
        } catch (e) {
          this.showToast('No addon found', 'Error');
        }

        await this.$store.commit('set', ['showLoader', false]);
      }
    },
    async selectAddonSearchedProduct(index) {
      let ecommerce_product = this.addon_search_products[index];
      let company = this.$store.getters.company;
      if(company.platform != 'wordpress' && !ecommerce_product.variant_id ) {
        this.showToast('This product not configured correctly on ecommerce platform.')
        return;
      }

      let payload = {
        product_id: this.id,
        addon_id: this.current_addon_id,
        ecommerce_post_id : ecommerce_product.product_id,
        ecommerce_variant_id : ecommerce_product.variant_id
      };

      await this.$store.commit('set', ['showLoader', true]);
      let res = await http.post("addon/sync", payload);
      let res_data = res.data;
      if (res_data.success) {
        this.showToast(res_data.message, 'SUCCESS');
        this.$bvModal.hide('addonSearchProductsModal');
        setTimeout(function () { window.location.reload(); }, 1000)
      } else {
        this.showToast(res_data.message, 'ERROR');
      }
      await this.$store.commit('set', ['showLoader', false]);

    },
    async dissociateAddon(addon_id) {

      await this.$store.commit('set', ['showLoader', true]);
      let payload = { addon_id }
      let res = await http.post("addon/dissociate", payload);
      let res_data = res.data;
      if (res_data.success) {
        this.showToast(res_data.message, 'SUCCESS');
        setTimeout(function () { window.location.reload(); }, 1000)
      } else {
        this.showToast(res_data.message, 'ERROR');
      }
      await this.$store.commit('set', ['showLoader', false]);

    },
    async createOrUpdateLogosGroup() {
      // Form validation for both cases create and edit
      const isValid = await this.$refs.groupValidationObserver.validate();

      // If any of the observers are invalid, show an error and return
      if (!isValid) {
        this.showToast('Please fill all required fields for the group.', 'error');
        return;
      }

      if(this.isGroupEditMode) {
        // update existing group
        const group_name = this.add_edit_group_info_obj.group_name
        const active_style = this.product_styles[this.active_style_index]
        const active_group = active_style.grouped_logos_info.grouped_logos[group_name]
        const ungrouped_logos = active_style.grouped_logos_info.ungrouped_logos
        const style_selected_logo_ids = this.add_edit_group_info_obj.selected_logos.map(selected_logo => {
          return selected_logo.id
        })

        const group_selected_logos = []
        active_style.grouped_logos_info.grouped_logos[group_name].logos.forEach(grouped_logo => {
          if (style_selected_logo_ids.includes(grouped_logo.id)) {
            group_selected_logos.push(grouped_logo)
          } else {
            ungrouped_logos.push(grouped_logo)
          }
        })

        const filtered_ungrouped_logos = active_style.grouped_logos_info.ungrouped_logos.filter(ungrouped_logo => {
          if (style_selected_logo_ids.includes(ungrouped_logo.id)) {
            if (!ungrouped_logo.file && ungrouped_logo.logo_url) {
              ungrouped_logo.file = { file_url: ungrouped_logo.logo_url, id: ungrouped_logo.id }
            }
            else if (!ungrouped_logo.file){
              ungrouped_logo.file = { file_url: '' }
            }
            group_selected_logos.push(ungrouped_logo);
            return false;
          }
          return true;
        });
        
        this.$set(active_style.grouped_logos_info.grouped_logos[group_name], "logos", group_selected_logos)
        this.$set(active_style.grouped_logos_info, "ungrouped_logos", filtered_ungrouped_logos)
        this.$bvModal.hide("add-edit-groups-modal")
      } else {
        // Create new logos group
        const active_style = this.product_styles[this.active_style_index]
        const active_style_groupes = active_style.grouped_logos_info.grouped_logos
        let active_style_groupe_names = Object.keys(active_style.grouped_logos_info.grouped_logos).map(group_name => {
          return group_name.toLowerCase()
        })
        if (active_style_groupe_names.includes(this.add_edit_group_info_obj.group_name.toLowerCase())) {
          this.showToast(`"Group with name (${this.add_edit_group_info_obj.group_name}) already exists"`, 'error');
          return;
        } else {
          const style_selected_remaining_logos = this.getStyleUngroupedSelectedRemainingLogos()
          this.$set(active_style.grouped_logos_info.grouped_logos, this.add_edit_group_info_obj.group_name, this.getGroupDefaultObject({
            style_id: active_style.style_id, logos: style_selected_remaining_logos.selected_logos, title: this.add_edit_group_info_obj.group_name, company_id: this.auth_user.company_id
          }))
          this.$set(active_style.grouped_logos_info, "ungrouped_logos", style_selected_remaining_logos.remaining_logos)
          this.$bvModal.hide('add-edit-groups-modal');
        }
      }      
    },
    getStyleUngroupedSelectedRemainingLogos() {
      const active_style = this.product_styles[this.active_style_index]
      let style_ungrouped_selected_logos = active_style.grouped_logos_info.ungrouped_logos.filter(ungrouped_logo => {
        let is_selected = this.add_edit_group_info_obj.selected_logos.map(selected_logo => {
          return selected_logo.id
        }).includes(ungrouped_logo.id)
        if (is_selected) {
          if (!ungrouped_logo.file && ungrouped_logo.logo_url) {
            ungrouped_logo.file = { file_url: ungrouped_logo.logo_url, id: ungrouped_logo.id};
          }
          else if(!ungrouped_logo.file){
            ungrouped_logo.file = { file_url: '' };
          }
        }
        return is_selected
      })
      let style_ungrouped_remaning_logos = active_style.grouped_logos_info.ungrouped_logos.filter(ungrouped_logo => {
        return !(this.add_edit_group_info_obj.selected_logos.map(selected_logo => {
          return selected_logo.id
        }).includes(ungrouped_logo.id))
      })
      return { selected_logos: style_ungrouped_selected_logos, remaining_logos: style_ungrouped_remaning_logos }

    },
    restoreRemovedLogosToUngrouped(originalLogos, updatedLogos) {

      // Determine logos that were removed during editing
      const removedLogos = originalLogos.filter(
        originalLogo => !updatedLogos.some(updatedLogo => updatedLogo.id === originalLogo.id)
      );

      removedLogos.forEach(logo => {
        // Add the removed logo back to `ungroupedLogosOptions` if not already there
        const existsInUngrouped = this.ungroupedLogosOptions.some(option => option.id === logo.id);
        if (!existsInUngrouped) {
          this.ungroupedLogosOptions.push({
            ...logo,
            side: this.sideOptionFor(logo.side, logo.face) // Ensure the side object is set (side+face aware)
          });
        }

        // Add the removed logo back to `style.fixed_logos` for the relevant style
        this.product_styles.forEach(style => {
          const existsInStyle = style.fixed_logos.some(fixedLogo => fixedLogo.id === logo.id);
          if (!existsInStyle) {
            style.fixed_logos.push({
              ...logo,
              logo_url: logo.file ? logo.file.file_url : '',
              side: this.sideOptionFor(logo.side, logo.face) // Ensure the side object is set (side+face aware)
            });
          }
        });
      });
    },
    removeSelectedLogosFromStyle() {
      // Loop through the product styles and remove the logos that are now grouped
      this.product_styles.forEach(style => {
        // Filter out the selected logos from the style
        style.fixed_logos = style.fixed_logos.filter(logo =>
          !this.selectedGroupLogos.some(selectedLogo => selectedLogo.id === logo.id)
        );
      });
    },
    removeSelectedLogosFromUngrouped(style) {
      // Remove logos from ungrouped logos options after they have been selected for grouping
      // const ungroupedLogos = style.grouped_logos_info?.ungrouped_logos || {};
      style.grouped_logos_info?.ungrouped_logos.forEach(logo => {
        const index = this.ungroupedLogosOptions.findIndex(option => option.id === logo.id);
        if (index !== -1) {
          this.ungroupedLogosOptions.splice(index, 1);  // Remove from ungrouped options
        }
      });

    },
    async fetchProductStyleList() {
      this.product_styles = [];
      let res = await http.get(`get-default-style-fixed-logos/${this.id}`);
      this.styles = res.data.result.styles // need to improve check
      this.is_reversible = res.data.result.is_reversible == true;

      if (res.data.result.styles) {
        res.data.result.styles.forEach((style) => {
          let style_obj = { grouped_logos_info: { grouped_logos: {}, ungrouped_logos: [] } }
          style_obj.tab_title = style.name;
          style_obj.style_id = style.id;
          style_obj.is_fixed_logos_all = Object.prototype.hasOwnProperty.call(style, 'is_fixed_logos_all') ? style.is_fixed_logos_all : true;

          style_obj.fixed_logos = [];
          if (style.logo.length > 0) {

            style_obj.grouped_logos_info.grouped_logos = Object.assign({}, style.grouped_logos_info.grouped_logos);
            for (let group_name in style_obj.grouped_logos_info.grouped_logos) {
              style_obj.grouped_logos_info.grouped_logos[group_name].logos.forEach(grouped_logo => {
                grouped_logo.logo_url = grouped_logo.file ? grouped_logo.file.file_url : ''
                grouped_logo.is_locked = !(grouped_logo.is_locked === false || grouped_logo.is_locked === 0)
              });
            }

            style_obj.grouped_logos_info.ungrouped_logos = style.grouped_logos_info.ungrouped_logos.map(ungrouped_logo => {
              ungrouped_logo.logo_url = ungrouped_logo.file ? ungrouped_logo.file.file_url : ''
              ungrouped_logo.is_locked = !(ungrouped_logo.is_locked === false || ungrouped_logo.is_locked === 0)
              return ungrouped_logo
            })

            for (let i = 0; i < style.logo.length; i++) {
              let logo = style.logo[i];
              let is_default = logo.is_default;
              let logo_side = this.sideOptionFor(logo.side, logo.face);
              style_obj.fixed_logos.push({
                id: logo.id,
                placement_title: logo.placement_title,
                x_axis: logo.x_axis,
                y_axis: logo.y_axis,
                rotation: logo.rotation,
                logo_url: logo.file ? logo.file.file_url : '',
                width: logo.width,
                height: logo.height,
                file_id: logo.file_id,
                side: logo_side,
                fixed_logo_id: logo.id,
                is_default: is_default,
                is_customizable: logo.is_customizable,
                is_locked: logo.is_locked
              })
            }
          } else {
            style_obj.fixed_logos.push({ ...default_fixed_logo_obj, is_default: true,style_id: style_obj.style_id })
            if (checkIsEmpty(style_obj.grouped_logos_info.grouped_logos) && style_obj.grouped_logos_info.ungrouped_logos.length === 0) {
              style_obj.grouped_logos_info.ungrouped_logos.push({ ...default_fixed_logo_obj, is_default: true,style_id: style_obj.style_id })
            }
          }
          this.product_styles.push(style_obj);
        })

        this.updateDefaultValues();
      }
    },
    confirmGroupDeletion(groupName) {

      this.$bvModal.msgBoxConfirm('Are you sure you want to delete this group? All its logos will be moved to the ungrouped section')
        .then(confirmed => {
          if (confirmed) {
            this.deleteGroup(groupName);
          }
        })
        .catch(err => {
          console.error('Error showing confirmation:', err);
        });
    },
    deleteGroup(groupName) {
      const active_style = this.product_styles[this.active_style_index];
      const delete_group = active_style.grouped_logos_info.grouped_logos[groupName]
      console.log(delete_group);
      if(delete_group.id){
// Make API call to delete the group
http.delete(`/delete-group-logo/${delete_group.id}`)
        .then(response => {
          const { success, message, data } = response.data;

          if (success) {
            // Add ungrouped logos back to the ungrouped logos array
            if (data && Array.isArray(data)) {
              this.ungroupLogos(data);
            }

            // Remove the group from the UI using Vue.delete for reactivity
            this.$delete(active_style.grouped_logos_info.grouped_logos, groupName);

            // Show success toast
            this.$bvToast.toast(message || 'Group deleted successfully.', {
              variant: 'success',
              solid: true,
            });
          } else {
            this.$bvToast.toast(message || 'Failed to delete group.', {
              variant: 'danger',
              solid: true,
            });
          }
        })
        .catch(err => {
          this.$bvToast.toast('Failed to delete group. Please try again.', {
            variant: 'danger',
            solid: true,
          });
        });
      }
      else{
        this.ungroupLogos(active_style.grouped_logos_info.grouped_logos[groupName].logos)
        // Remove the group from the UI using Vue.delete for reactivity
        this.$delete(active_style.grouped_logos_info.grouped_logos, groupName);
      }
      
    },
    ungroupLogos(logos) {
      const active_style = this.product_styles[this.active_style_index]
      // Add ungrouped logos back to the ungrouped logos array
      logos.forEach(logo => {
        logo.group_id = null;
        logo.logo_url = logo.file.file_url;
         active_style.grouped_logos_info.ungrouped_logos.push(logo);
      });
    },
    editGroupNew(group_name) {
      const active_style = this.product_styles[this.active_style_index]
      const active_group = active_style.grouped_logos_info.grouped_logos[group_name]
      this.add_edit_group_info_obj.group_name = group_name
      this.add_edit_group_info_obj.selected_logos = active_group.logos
      this.isGroupEditMode = true
      this.add_edit_group_modal_options = [...active_style.grouped_logos_info.ungrouped_logos, ...active_group.logos]
      this.$bvModal.show("add-edit-groups-modal")
    },
    updateGroup() {
      const group_name = this.add_edit_group_info_obj.group_name
      const active_style = this.product_styles[this.active_style_index]
      const active_group = active_style.grouped_logos_info.grouped_logos[group_name]
      const ungrouped_logos = active_style.grouped_logos_info.ungrouped_logos
      const style_selected_logo_ids = this.add_edit_group_info_obj.selected_logos.map(selected_logo => {
        return selected_logo.id
      })
      const group_selected_logos = []
      for (const group_name in active_style.grouped_logos_info.grouped_logos) {
        active_style.grouped_logos_info.grouped_logos[group_name].logos.forEach(grouped_logo => {
          
          if (style_selected_logo_ids.includes(grouped_logo.id)) {
            group_selected_logos.push(grouped_logo)
          } else {
            ungrouped_logos.push(grouped_logo)
          }
        })
      }

      const filtered_ungrouped_logos = active_style.grouped_logos_info.ungrouped_logos.filter(ungrouped_logo => {
        if (style_selected_logo_ids.includes(ungrouped_logo.id)) {
          group_selected_logos.push(ungrouped_logo);
          return false; // Exclude this logo from the new ungrouped_logos array
        }
        return true; // Keep this logo in the ungrouped_logos array
      });

      this.$set(active_style.grouped_logos_info.grouped_logos[group_name], "logos", group_selected_logos)
      this.$set(active_style.grouped_logos_info, "ungrouped_logos", filtered_ungrouped_logos)
      this.$bvModal.hide("add-edit-groups-modal")
    },
    editGroup(group, style) {
      // Reset modal fields
      this.newGroupName = group.title;
      this.selectedGroupLogos = group.logos; // pre selected logos here
      this.editGroupObject = group;

      // Filter out grouped logos
      const ungroupedLogos = style.grouped_logos_info.ungrouped_logos;

      // Include logos from the current group in the ungrouped options
      const currentGroupLogos = group.logos.map(logo => ({
        ...logo,
        side: this.sideOptionFor(logo.side, logo.face), // Ensure side object exists (side+face aware)
      }));

      // Pass the ungrouped logos to the modal
      this.isGroupEditMode = true;
      this.ungroupedLogosOptions = [...ungroupedLogos, ...currentGroupLogos];
      let modalName = 'groupingModal-' + style.style_id;

      this.$bvModal.show(modalName);
    },
    getStyleAllLogoState(style) {

      // Handle undefined is_fixed_logos_all
      if (typeof style.is_fixed_logos_all === 'undefined') {
        this.$set(style, 'is_fixed_logos_all', true); // Ensure reactivity
      }

      // Update allLogosDisplayActive based on the selectedOption
      this.allLogosDisplayActive = this.selectedOption === 'all'
        ? true
        : this.selectedOption === 'either'
          ? false
          : style.is_fixed_logos_all;
    },
    async validateEitherTab() {
      let is_validated = true;
      let errorMessage = null;

      for (const product_style of this.product_styles) {
        const ungrouped_logos = product_style.grouped_logos_info.ungrouped_logos;
        for (const [ungroupedLogoIndex] of ungrouped_logos.entries()) {
          const observerKey = `observer-ungroup-${ungroupedLogoIndex}`;
          if (this.$refs[observerKey] && this.$refs[observerKey][0]) {
            const isLogoValidated = await this.$refs[observerKey][0].validate();
            if (!isLogoValidated) {
              is_validated = false;
              errorMessage = 'Please fill all required fields';
            }
          }
        }

        const grouped_logos = product_style.grouped_logos_info.grouped_logos;
        for (const group_name in grouped_logos) {
          const observerKey = `observer-group-${group_name}`;
          if (this.$refs[observerKey] && this.$refs[observerKey][0]) {
            const isGroupValidated = await this.$refs[observerKey][0].validate();
            if (!isGroupValidated) {
              is_validated = false;
              errorMessage = 'Please fill all required fields';
            }
          }
        }
      }

      if (!is_validated) {
        this.showToast(errorMessage, "error");
      }

      return is_validated;
    },
    handleAddEditGroupModalHideEvent() {
      this.isGroupEditMode = false
      this.getAddEditGroupInfoObject(true)
    }
  },
}
</script>
<style lang="scss">
.model_postion {
  width: 45px;
}

.error {
  color: #C80000;
}

.add-product-holder .card {
  border: none;
}

.add-product-holder .nav-pills .nav-link {
  background: #E8E8E8;
  color: #A1A1A1;
  border-radius: 15px 15px 0 0;
  padding: 0.5rem 1.5rem;
  font-size: 18px;
  font-weight: 300;
}

.add-product-holder .nav-pills .nav-link.active {
  background: #009FE3;
  color: #fff;
}

.add-product-holder .card-header {
  padding: 0 3rem;
  margin: 0 -2rem;
}

.add-product-holder .nav-item {
  margin: 0 25px 10px 0;
}

.add-product-holder .card-header-pills {
  margin: 0;
}

.btn-add-fields {
  position: relative;
  color: #fff;
  padding: 0;
  margin: 0;
  background: #009FE3;
  font-size: 34px;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  text-align: center;
  z-index: 2;
  border-color: #009FE3;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.btn-add-fields:before {
  position: absolute;
  content: '';
  left: 3px;
  right: 3px;
  top: 3px;
  bottom: 3px;
  border: 2px solid #fff;
  border-radius: 50%;
}

.btn-add-fields span {
  margin: -5px 0 0;
}

.styles-fields {
  padding: 1.25rem 0;
}

.v-image {
  border: 1px solid red;
  border-radius: 5px;
}

@media only screen and (max-width: 1430px) {
  .custom-switch.b-custom-control-lg .custom-control-label {
    font-size: 1rem;
  }
}

.remove-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2em;
  height: 30px;
  width: 30px;
  background: #C80000;
  color: #fff;
  border-radius: 99px;
  position: absolute;
  right: -10px;
  top: -10px;
  cursor: pointer;
  transition: 0.2s all ease;
  z-index: 30;
}

.clear-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1em;
  color: #fff;
  position: absolute;
  right: 40px;
  top: 58px;
  cursor: pointer;
  transition: 0.2s all ease;
  z-index: 30;
}


.remove-icon:hover {
  background: #ff0000;
}

.btn-primary.light {
  background: #c8e4f3 !important;
  border-color: #c8e4f3 !important;
  color: #009FE3 !important;
}

/* Table Styling */

.product-table {
  width: 100%;
  border-collapse: collapse;
  border: none;
  border-radius: 5px;
  overflow: hidden;
}

.product-table>th,
td {
  /* border: 1px solid black; */
  border-collapse: collapse;
}

.product-table>th,
td {
  padding: 10px;
}

.product-table>th {
  background-color: #E6E9EC;
  font-size: 20px;
  color: black;
}

.product-table>tr>td:nth-child(1) {
  background-color: #E6E9EC;
  font-size: 1em;
  color: black;
  font-weight: bold;
  width: 10%;
}

.product-table>td {
  background-color: #ffffff;
}


.center {
  margin-left: auto;
  margin-right: auto;
}

.price-input-label {
  display: flex;
  margin-right: 10px;
  justify-content: center;
  align-items: center;
}

.custom-radio {
  display: flex;
  align-items: center;
  gap: 10px;

  .radio_text {
    &>* {
      margin: 0;
      padding: 0;
    }
  }

  &>span {
    .radio_icon {
      display: block;
      flex-shrink: 0;
      width: 20px;
      height: 20px;
      border: 1px solid #009FE3;
      /* Green color for the checkmark */
      border-radius: 50%;
      /* Makes the border circular */
      position: relative;

      /* Rotating the square to create a checkmark */
      transform: rotate(0);
    }

    /* Styling for the checkmark itself */
    .radio_icon::before,
    .radio_icon::after {
      display: none;
      content: '';
      position: absolute;
      background-color: #fff;
      /* Green color for the checkmark */
    }

    .radio_icon::before {
      width: 6px;
      height: 2px;
      top: 9px;
      left: 3px;
      transform: rotate(45deg);
    }

    .radio_icon::after {
      width: 2px;
      height: 10px;
      top: 4px;
      left: 10px;
      transform: rotate(45deg);
    }

    input {
      display: none;

      &:disabled {
        &+.radio_icon {
          cursor: not-allowed;
          background-color: #eee;
          border-color: #ccc;

          &::before,
          &::after {
            display: block;
            background-color: #eee;
          }
        }
      }

      &:checked {
        &+.radio_icon {
          background-color: #009FE3;

          &::before,
          &::after {
            display: block;
            background-color: #fff;
          }
        }

        &:disabled {
          &+.radio_icon {
            cursor: not-allowed;
            background-color: #ccc;
            border-color: #aaa;

            &::before,
            &::after {
              display: block;
              background-color: #fff;
            }
          }
        }
      }
    }
  }

  &.checkbox {
    &>span {
      .radio_icon {
        border-radius: 20%;
      }
    }
  }
}

.compact-table {
  font-size: 0.75em;

  tr {
    td {
      padding: 5px;

      .form-control {
        font-size: inherit;
        padding: 5px 7px;
        height: 32px;
      }
    }
  }
}

.message {
  position: absolute;
  top: 60px;
  left: -100px;
  /* Adjust this value according to your layout */
  background-color: #fff;
  border: 1px solid #ccc;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.border-light-gray {
  border-color: #ccc !important;
}

.section-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #333;
  border-bottom: 2px solid #009FE3;
  /* Border below the heading */
  padding-bottom: 10px;
  margin-bottom: 15px;
}

.section-title-text {
  font-size: 1.5rem;
  color: #005F87;
}

.group-name-heading {
  background-color: #009FE3;
  /* Blue background */
  color: #fff;
  /* White text color */
  padding: 5px 10px;
  /* Padding around the text */
  font-size: 1.25rem;
  /* Slightly larger font size */
  font-weight: 600;
  /* Bold text */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  /* Subtle shadow */
}
</style>
